/**
 * Whitelist des appels API pour le mécanisme **500** (incident serveur).
 *
 * - **503** sur *n'importe quel* endpoint → maintenance immédiate (intercepteur axios).
 * - **500** sur ces endpoints (après retries) → page maintenance.
 * - **500** ailleurs → gestion locale (toast, champ, etc.).
 */

/** GET indispensables au démarrage ou à la session connectée. */
export const MAINTENANCE_CRITICAL_GET_PATHS = [
  '/workspaceConfigs',
  '/users/me',
  '/locales',
  '/routes'
] as const;

/** POST indispensables (connexion). */
export const MAINTENANCE_CRITICAL_POST_PATHS = ['/auth'] as const;

/** Nombre de nouvelles tentatives après le premier échec (3 appels au total). */
export const MAINTENANCE_CRITICAL_RETRY_COUNT = 2;

/**
 * Normalise une URL axios (relative ou absolue) en pathname sans query ni slash final.
 */
export function normalizeApiPath(url: string): string {
  const pathname = url.startsWith('http') ? new URL(url).pathname : url.split('?')[0];
  return pathname.replace(/\/+$/, '') || '/';
}

/**
 * Indique si la requête HTTP fait partie de la whitelist maintenance.
 * Utilisé pour documenter / tester la politique ; le déclenchement réel
 * se fait via React Query (boot) ou `triggerServerError` (login, locales).
 */
export function isMaintenanceCriticalApiCall(
  method: string | undefined,
  requestUrl: string | undefined
): boolean {
  if (!requestUrl) {
    return false;
  }

  const path = normalizeApiPath(requestUrl);
  const normalizedMethod = (method ?? 'get').toLowerCase();

  if (normalizedMethod === 'get') {
    return (MAINTENANCE_CRITICAL_GET_PATHS as readonly string[]).includes(path);
  }

  if (normalizedMethod === 'post') {
    return (MAINTENANCE_CRITICAL_POST_PATHS as readonly string[]).includes(path);
  }

  return false;
}
